import React, { useEffect } from "react";
import StandaloneModalManager from "./StandaloneModalManager";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { customOpenPanel } from "../../index";
import { StandaloneModal } from "../../components/layout/StandaloneModal";

export interface StandaloneModalState {
  errorDetails: {
    title: string;
    message: string;
    type: string;
  } | null;
}

export const StandaloneModalContainer: React.FunctionComponent = () => {
  const [state, setState] = React.useState<StandaloneModalState>({
    errorDetails: null,
  });

  useEffect(() => {
    StandaloneModalManager.addChangeListener(handleStoreChange);
    return () => {
      StandaloneModalManager.removeChangeListener(handleStoreChange);
    };
  }, []);

  function handleStoreChange(errorDetails: StandaloneModalState["errorDetails"]) {
    if (errorDetails) customOpenPanel();
    setState({
      errorDetails,
    });
  }

  const visible = state.errorDetails !== null;

  if (visible)
    return (
      <StandaloneModal
        modalTitle={state.errorDetails.title}
        icon={"/assets/notCompatible.svg"}
        alt={state.errorDetails.message}
        message={state.errorDetails.message}
        type={state.errorDetails.type.toLowerCase() == "error" ? "delete" : "confirm"}
        actions={[
          {
            id: "back_button",
            title: formatMessage("cof.base.back"),
            onClick: () => {}, //onClick on an action onHide will be called
            variant: "blue",
          },
        ]}
        onHide={() => setState({ errorDetails: null })}
      />
    );
  return null;
};

export default StandaloneModalContainer;
